"use strict";

var __values = this && this.__values || function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
      m = s && o[s],
      i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function next() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.decodeConnection = exports.decodeConnections = void 0;

function decodeConnections(c) {
  var e_1, _a;

  var connections = [];

  try {
    for (var c_1 = __values(c), c_1_1 = c_1.next(); !c_1_1.done; c_1_1 = c_1.next()) {
      var conn = c_1_1.value;
      connections.push(decodeConnection(conn));
    }
  } catch (e_1_1) {
    e_1 = {
      error: e_1_1
    };
  } finally {
    try {
      if (c_1_1 && !c_1_1.done && (_a = c_1.return)) _a.call(c_1);
    } finally {
      if (e_1) throw e_1.error;
    }
  }

  return connections;
}

exports.decodeConnections = decodeConnections;

function decodeConnection(c) {
  var lastUse = new Date(c.lastUse);
  return new Connection(c.hostname, c.port, c.quality, c.type, lastUse);
}

exports.decodeConnection = decodeConnection;

var Connection =
/** @class */
function () {
  function Connection(hostname, port, quality, type, lastUse) {
    this.hostname = hostname;
    this.port = port;
    this.quality = quality;
    this.type = type;
    this.lastUse = lastUse;
  } // TODO: move this to backend


  Connection.prototype.pathType = function () {
    if (this.hostname) {
      if (this.hostname.length > 15) {
        var block = this.hostname.split(':');

        if (block[0] === '2002') {
          return '6to4 IPv6';
        } else if (block[0] === '2001' && block[1] === '') {
          return 'Teredo IPv6';
        }

        return 'IPv6';
      } else {
        var octet = this.hostname.split('.');

        if (octet[0] === '10') {
          if (octet[1] === '128') {
            // LTE/3G
            return 'Comsel Cellular';
          } else if (octet[1] === '159') {
            // NB-IoT
            return 'Comsel Cellular - NB-IoT';
          } else if (octet[1] === '192') {
            return 'Comsel Secure Network';
          } else {
            return 'Comsel Intranet';
          }
        } else {
          if (!isNaN(parseInt(octet[0]))) {
            return 'Fixed IPv4';
          }
        }
      }
    }

    return 'Unknown';
  };

  return Connection;
}();

exports.default = Connection;